import { render, staticRenderFns } from "./newCourse.vue?vue&type=template&id=24147f96&scoped=true"
import script from "./newCourse.vue?vue&type=script&lang=ts"
export * from "./newCourse.vue?vue&type=script&lang=ts"
import style0 from "./newCourse.vue?vue&type=style&index=0&id=24147f96&prod&scoped=true&lang=scss"
import style1 from "./newCourse.vue?vue&type=style&index=1&id=24147f96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24147f96",
  null
  
)

export default component.exports